import React from 'react'
import { BrowserRouter, Route, Routes as RouterRoutes } from 'react-router-dom'
import HomePage from './components/pages/HomePage/HomePage'
import AuthLayout from './components/AuthLayout'
import GenePageContainer from './components/pages/GenePage/GenePageContainer'
import DataInfoPage from '@/components/pages/DataInfoPage/DataInfoPage'
import RegionPageContainer from './components/pages/RegionPage/RegionPageContainer'
import TranscriptPageContainer from './components/pages/TranscriptPage/TranscriptPageContainer'
import VariantPageContainer from './components/pages/VariantPage/VariantPageContainer'
import NotFoundPage from '@/components/pages/NotFoundPage/NotFoundPage'
import JobsPageContainer from '@/components/pages/JobsPage/JobsPageContainer'
import NewJobPageContainer from '@/components/pages/NewDatasetJobPage/NewJobPageContainer'
import {ROUTES} from '@/utils/routes'
import NewDatabaseJobPage from '@/components/pages/NewDatabaseJobPage/NewDatabaseJobPage'
import AuthCallbackPage from '@/components/pages/AuthCallbackPage'
import SecuredRoute from '@/auth/SecuredRoute'

export default function Routes() {
    return (
        <BrowserRouter>
            <RouterRoutes>
                <Route path={ROUTES.HOME} element={<AuthLayout />}>
                    <Route index element={<HomePage />} />
                    <Route path={ROUTES.DATA_INFO} element={<DataInfoPage />} />
                    <Route path={ROUTES.SEARCH} element={<HomePage />} />
                    <Route element={<SecuredRoute/>} >
                        <Route path={ROUTES.JOBS_DATASET} element={<JobsPageContainer />} />
                        <Route path={ROUTES.NEW_DATASET} element={<NewJobPageContainer />} />
                        <Route path={ROUTES.NEW_DATABASE} element={<NewDatabaseJobPage />} />
                    </Route>
                    <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />}  />
                    <Route path={ROUTES.GENE} element={<GenePageContainer />} />
                    <Route
                        path={ROUTES.REGION}
                        element={<RegionPageContainer />}
                    />
                    <Route
                        path={ROUTES.TRANSCRIPT}
                        element={<TranscriptPageContainer />}
                    />
                    <Route
                        path={ROUTES.VARIANT}
                        element={<VariantPageContainer />}
                    />
                </Route>
                <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallbackPage/>}/>
            </RouterRoutes>
        </BrowserRouter>
    )
}
